import React, { useState } from "react";
import "../../../assets/scss/home.scss";
import "../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";
import Repository from "../../../configs/axios/repository";
import Swal from "sweetalert2";

const CreateCourse = (props) => {
    const history = useHistory();
    const [loadingData, setLoadingData] = useState(true);
    const [tags, setTags] = useState([]);

    const hendleSubmit = async (values) => {
        const resultData = await Repository.postRequest(
            `api/course/createCourse`,
            {
                course_name: values.course_name,
                description: values.description,
                icon: "string",
                user_id: {
                    user_id: 0,
                },
            }
        );

        let courseName = resultData.data.data.course_name;
        if (resultData.status === 200 || resultData.status === 201) {
            if (tags.length != 0) {
                addStudents(resultData.data.data.course_id, courseName);
            }
            setTags([]);
            Swal.fire({
                title: "The course has been successfully created.",
                icon: "success",
                confirmButtonColor: "#16285e",
            }).then((result) => {
                if (result.isConfirmed) {
                    history.push({
                        pathname: "/courseStudents",
                        search: `course_id=${resultData.data.data.course_id}`,
                        state: { courseName },
                    });
                }
            });
        }
    };
    const addStudents = async (val, courseName) => {
        let newData = {
            email: tags.map((nm) => {
                return nm.text;
            }),
            course_id: val,
        };
        const response = await Repository.postRequest(
            `api/students/createStudents`,
            newData
        );
        if (response.data?.success === true) {
            sendInvate(val, courseName);
        }
    };
    const sendInvate = async (val, courseName) => {
        setLoadingData(false);
        let newData = {
            email: tags.map((nm) => {
                return nm.text;
            }),
            course_id: val,
            course_name: courseName,
        };

        const response = await Repository.postRequest(
            `api/users/sendInvateEmail`,
            newData
        );
        if (response.data?.success === true) {
            setLoadingData(true);
        }
        setLoadingData(true);
    };

    return loadingData ? (
        <div className="testBodyDiv homeSection mt-3">
            <div className="sectionHeaderDiv">
                <h1 className="createtestH1">Create Course</h1>
            </div>
            <div className="mt-3">
                <Formik
                    initialValues={{
                        course_name: "",
                        description: "",
                    }}
                    validate={(values) => {
                        const errors = {};

                        if (!values.course_name) {
                            errors.course_name = "Create name is required.";
                        }

                        return errors;
                    }}
                    onSubmit={(values) => {
                        hendleSubmit(values);
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="formikEvents">
                            <Row>
                                <Col xl="12" md="12" sm="12">
                                    <div className="labelInputsStyle">
                                        Course Name
                                    </div>

                                    <Field
                                        className="formikInputTest"
                                        type="text"
                                        name="course_name"
                                        placeholder="Course name"
                                    />
                                    <ErrorMessage
                                        className="errorMessage"
                                        name="course_name"
                                        component="div"
                                    />
                                </Col>
                                <Col xl="12" md="12" sm="12">
                                    <div className="labelInputsStyle">
                                        Description
                                    </div>
                                    <Field
                                        as="textarea"
                                        className="formikDescription"
                                        name="description"
                                        rows="8"
                                    />
                                </Col>

                                <Col xl="12" md="12" sm="12">
                                    <div id="btnNextTest" className="testBtn">
                                        <button
                                            onClick={() => {
                                                history.push("/courses");
                                            }}
                                            type="button"
                                            className="btnOkTest"
                                        >
                                            Back
                                        </button>
                                        <button
                                            type="submit"
                                            className="btnNextTest"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default CreateCourse;
